<template>
    <section class="row-12">
        <folder-list @select-folder="changeFolder" ref="folders" class="col-12"></folder-list>

        <h2 class="col-4 col-sm-12" v-if="activeFolder">Projekty z folderu "{{activeFolder.name}}"</h2>
        <h2 class="col-4 col-sm-12" v-else>Nie wybrano folderu</h2>
        <div class="col-8 col-sm-12">
            <div class="row-12 m-t-2">
                <div class="col-3 col-sm-12 input-with-icon-close center-flex-y">
                    <input id="calendarPickerFrom" class="calendarPicker" placeholder="Data od"/>
                    <i class="i-calendar"></i>
                    <i class="i-cross" @click="removeData('#calendarPickerFrom')"></i>
                </div>
                <div class="col-3 col-sm-12 input-with-icon-close center-flex-y">
                    <input id="calendarPickerTo" class="calendarPicker" placeholder="Data do"/>
                    <i class="i-calendar"></i>
                    <i class="i-cross" @click="removeData('#calendarPickerTo')"></i>
                </div>
                <div class="col-6 col-sm-12 input-with-icon">
                    <input id="searchFilter" v-model="inputText" placeholder="Wyszukaj..."/>
                    <i class="i-search"></i>
                </div>
            </div>
        </div>

        <div class="col-12 m-t-1 m-b-5">
            <div class="row-12" v-if="filteredList.length > 0">
                <div class="card col-4 col-sm-12 col-md-6 wow fadeIn" v-for="animeCard in filteredList"
                     :key="animeCard.id">
                    <div class="card-image">
                        <img :src="animeCard.main_image" :id="'animeCardImg-'+animeCard.id" :alt="animeCard.name">
                        <div class="side-menu">
                            <c-sidemenu
                                    :icon="'i-sm i-eye'"
                                    @click.native="showAnim(animeCard.id,animeCard.url,animeCard.name)"
                                    :links="[{name: 'Podgląd'}]"
                            />
                            <c-sidemenu
                                    :icon="'i-sm i-compose'"
                                    @click.native="goToEditProject(animeCard.id)"
                                    :links="[{name: 'Edytuj'}]"
                            />
                            <c-sidemenu
                                    :icon="'far fa-copy'"
                                    @click.native="copyProject(animeCard.id)"
                                    :links="[{name: 'Kopiuj'}]"
                            />
                            <c-sidemenu
                                    :icon="'i-sm i-download'"
                                    @click.native="downloadModal(animeCard.main_image,animeCard.url,animeCard.name,animeCard.id)"
                                    :links="[{name: 'Pobierz'}]"
                            />
                            <c-sidemenu
                                    :icon="'i-sm i-share'"
                                    @click.native="shareModal(animeCard.id)"
                                    :links="[{name: 'Udostępnij'}]"
                            />
                            <c-sidemenu
                                    :icon="'i-sm i-cross'"
                                    @click.native="deleteAnimation(animeCard.id)"
                                    :links="[{name: 'Usuń'}]"
                            />
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row-12">
                            <div class="col-12 center-flex-a" style="justify-content: flex-end">
                                <i class="i-calendar text-primary i-md"></i>
                                <small> {{animeCard.date_add}}</small>
                            </div>
                        </div>
                        <h4 class="m-t-2">{{animeCard.name}}</h4>
                        <p v-if="animeCard.description.length > 0">{{strip(animeCard.description)}}</p>
                        <p v-else> Ten projekt nie posiada opisu. Przejdź do edycji, aby go uzupełnić.</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-12" v-else>
                <error-notifier
                        type="info"
                        title="Brak projektów do wyświetlenia"
                        message="Nie stworzyłeś jeszcze żadnych projektów, które moglibyśmy tu wyświetlić."
                />
            </div>
        </div>
        <div class="modal" id="modalPromptForDelete">
            <div class="modal-header">
                Nieodwracalne usunięcie projektu
            </div>
            <div class="modal-body">
                <p>Jesteś pewny, że chcesz usunąć dany projekt?</p>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="denyDelete()">Anuluj</button>
                <button @click="allowDelete()">Tak, usuń</button>
            </div>
        </div>
        <div class="modal" id="downloadModal">
            <div class="modal-header">
                Pobieranie zawartości
            </div>
            <div class="modal-body center-flex-a">
                <button @click="downloadVideo()">Pobierz film (.mp4)</button>
                <button @click="donwloadFirstImg()">Pobierz 1 klatkę (.jpg)</button>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="hideModal('#downloadModal')">Anuluj</button>
            </div>
        </div>
        <div class="modal" id="shareModal">
            <div class="modal-header">
                Udostępnij znajomym
            </div>
            <div v-if="!this.$vuetify.breakpoint.smAndDown" class="modal-body center-flex-a">
                <p class="text-a-c">Kliknij w daną osobę w liście znajomych, aby przenieść ją do udostępnionych, lub odwrotnie</p>
                <div class="row-12">
                    <div class="col-6">
                        <div class="header-list">Lista znajomych</div>
                        <div class="left-friends-list m-y-4">
                            <div class="card m-t-1" v-for="(friend, key) in sharedData.friendsNoShared" v-on:click="addToShare(friend, key)">
                                <div class="card-body display-flex" style="position: relative;">
                                    <div class="center-flex-a" style="height: auto;">
                                        <img class="circle-profile" :src="friend.profile_img"
                                             :alt="friend.firstname">
                                    </div>
                                    <div class="p-l-4" style="width: calc(100% - 70px); align-self: center">
                                        <h5 class="text-second w-100">{{friend.firstname}}
                                            <b>{{friend.lastname}}</b></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="header-list">Udostępnione dla</div>
                        <div class="right-friends-list m-y-4">
                            <div class="card m-t-1" v-for="(shared, key) in sharedData.friendsShared">
                                <div class="card-body display-flex" style="position: relative;">
                                    <div class="center-flex-a" style="height: auto;">
                                        <img class="circle-profile" :src="shared.profile_img"
                                             :alt="shared.firstname">
                                    </div>
                                    <div class="p-l-4" style="width: calc(100% - 70px); align-self: center">
                                        <h5 class="text-second w-100">{{shared.firstname}}
                                            <b>{{shared.lastname}}</b></h5>
                                    </div>
                                    <span class="deleteFriend" @click="deleteFromShared(shared, key)">
                                        <i class="i-cross"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="modal-body center-flex-a">
                <div class="row-12">
                    <div class="col-12">
                        <p class="text-a-c">Wybierz czy chcesz udostępnić nowej osobie ("Lista znajomych") czy też usunąć dostęp komuś komu już udostępniasz ("Udostępnione dla")</p>
                        <div class="share-titles">
                            <div v-on:click="changeList(true)" class="header-list">Lista znajomych</div>
                            <div v-on:click="changeList(false)" class="header-list">Udostępnione dla</div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div v-show="friends" class="center-flex-a">
                            <div class="left-friends-list m-y-4">
                                <div class="card m-t-1" v-for="(friend, key) in sharedData.friendsNoShared" v-on:click="addToShare(friend, key)">
                                    <div class="card-body display-flex" style="position: relative;">
                                        <div class="center-flex-a" style="height: auto;">
                                            <img class="circle-profile" :src="friend.profile_img"
                                                 :alt="friend.firstname">
                                        </div>
                                        <div class="p-l-4" style="width: calc(100% - 70px); align-self: center">
                                            <h5 class="text-second w-100">{{friend.firstname}}
                                                <b>{{friend.lastname}}</b></h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="!friends" class="center-flex-a">
                            <div class="right-friends-list m-y-4">
                                <div class="card m-t-1" v-for="(shared, key) in sharedData.friendsShared">
                                    <div class="card-body display-flex" style="position: relative;">
                                        <div class="center-flex-a" style="height: auto;">
                                            <img class="circle-profile" :src="shared.profile_img"
                                                 :alt="shared.firstname">
                                        </div>
                                        <div class="p-l-4" style="width: calc(100% - 70px); align-self: center">
                                            <h5 class="text-second w-100">{{shared.firstname}}
                                                <b>{{shared.lastname}}</b></h5>
                                        </div>
                                        <span class="deleteFriend" @click="deleteFromShared(shared, key)">
                                        <i class="i-cross"></i>
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="hideModal('#shareModal')">Anuluj</button>
            </div>
        </div>

    </section>
</template>

<script>
    import SideMenu from '../../components/CardSideMenu'
    import Search from '../../components/Search.vue'
    import ErrorNotifier from '../../components/ErrorFullNotifier'
    import FolderList from '../../components/FolderList'

    export default {
        components: {
            'c-sidemenu': SideMenu,
            'c-search': Search,
            'error-notifier': ErrorNotifier,
            'folder-list': FolderList,
        },
        data: () => {
            return (
                {
                    activeFolder: {
                        id: null,
                        name: ''
                    },
                    elementToDeleteId: null,
                    showAlphabetically: false,
                    downloadData: {
                        img: '',
                        video: '',
                        name: '',
                        id: ''
                    },
                    showChronological: false,
                    friends: true,
                    animationList: [],
                    filteredList: [],
                    sharedData: {
                        friendsNoShared: [],
                        friendsShared: []
                    },
                    icon: {
                        type: String,
                        required: false,
                        default: ''
                    },
                    links: {
                        type: String,
                        required: false,
                        default: ''
                    },
                    location: {
                        type: String,
                        required: false,
                        default: ''
                    },
                    inputText: '',
                    pickedDate: ''
                }
            );
        },
        methods: {
            copyProject(id){
                axios.post(`animations/${id}/copy`)
                    .then((response) => {
                        notify.createNotifier("Animacja skopiowana pomyślnie.", "success", 2000);
                        this.$refs.folders.reset();
                    })
            },
            addToShare(friend, key) {
                axios.post(`animations/${this.actualSharedElementId}/share/${friend.id}`)
                    .then((response) => {
                        this.sharedData.friendsNoShared.splice(key, 1);
                        this.sharedData.friendsShared.push(friend);
                        notify.createNotifier("Udostępniono pomyślnie.", "success", 2000);
                    });
            },
            shareModal(id) {
                axios.get(`animations/${id}/sharedList`)
                    .then((response) => {
                        this.sharedData = {
                            friendsNoShared: response.data.friends,
                            friendsShared: response.data.shared
                        };
                        this.actualSharedElementId = id;
                        this.showModal('#shareModal');
                    });
            },
            deleteFromShared(friend, key) {
                axios.delete(`animations/${this.actualSharedElementId}/share/${friend.id}`)
                    .then((response) => {
                        this.sharedData.friendsShared.splice(key, 1);
                        this.sharedData.friendsNoShared.push(friend);
                        notify.createNotifier("Cofnięto udostępnienie.", "success", 2000);
                    });
            },
            changeList(type) {
                this.friends = type;
            },
            strip(html) {
                let tmp = document.createElement("DIV");
                tmp.innerHTML = html;
                return tmp.textContent || tmp.innerText || "";
            },
            downloadModal(img, video, name, id) {
                axios.get(`animations/${id}/imgId`)
                    .then((response)=>{
                        this.downloadData ={
                            img: response.data.main_image,
                            video: response.data.url,
                            name: name,
                            id: id
                        };
                        this.showModal('#downloadModal');
                    });
            },
            donwloadFirstImg() {
                axios.get(`file/download/${this.downloadData.img}`, {responseType: 'blob'})
                    .then((response) => {
                        if (response.data) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', this.downloadData.name + ".jpg");
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            notify.createNotifier("Pobieranie pliku .jpg rozpoczęte.", "info", 2000);
                        } else {
                            notify.createNotifier("Niestety nie można pobrać teraz zdjęcia. Spróbuj ponownie za chwilkę.", "danger", 4000);
                        }
                    })
                    .catch(() => {
                        notify.createNotifier("Niestety Twój film nie został jeszcze wyrenderowany. Prosimy spróbuj za minutę.", "danger", 4000);
                    });
                this.hideModal('#downloadModal');
            },
            downloadVideo() {
                axios.get(`file/download/${this.downloadData.video}`, {responseType: 'blob'})
                    .then((response) => {
                        if (response.data) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', this.downloadData.name + ".mp4");
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            notify.createNotifier("Pobieranie pliku .mp4 rozpoczęte.", "info", 2000);
                        } else {
                            notify.createNotifier("Niestety Twój film nie został jeszcze wyrenderowany. Prosimy spróbuj za minutę.", "danger", 4000);
                        }
                    })
                    .catch(() => {
                        notify.createNotifier("Niestety Twój film nie został jeszcze wyrenderowany. Prosimy spróbuj za minutę.", "danger", 4000);
                    });
                this.hideModal('#downloadModal');
            },
            goToEditProject(id) {
                this.$router.push('editAnimation/' + id);
            },
            showAnim(id, url, name) {
                axios.get(`animations/${id}/imgId`)
                    .then((response)=>{
                        axios.get(`file/download/${response.data.url}`, {responseType: 'blob'})
                            .then((response) => {
                                if (response.data) {
                                    this.$router.push('viewAnimation/'+id);
                                } else {
                                    notify.createNotifier("Niestety Twój film nie został jeszcze wyrenderowany. Poczekaj na zakończenie zanim przejdziesz do podglądu.", "danger", 4000);
                                }
                            })
                            .catch(() => {
                                notify.createNotifier("Niestety Twój film nie został jeszcze wyrenderowany. Poczekaj na zakończenie zanim przejdziesz do podglądu.", "danger", 4000);
                            })
                    });
            },
            removeData(name) {
                $(name).val('');
                this.filterDate();
            },
            deleteAnimation(id) {
                this.elementToDeleteId = id;
                this.showModal('#modalPromptForDelete');
            },
            denyDelete() {
                this.hideModal('#modalPromptForDelete');
            },
            allowDelete() {
                this.hideModal('#modalPromptForDelete');
                if (this.elementToDeleteId) {
                    axios.delete(`animations/${this.elementToDeleteId}`)
                        .then((response) => {
                            notify.createNotifier("Projekt został usunięty.", "success", 2000);
                            for (let i = 0; i < this.animationList.length; i++) {
                                if (this.animationList[i].id == this.elementToDeleteId) {
                                    this.animationList.splice(i, 1);
                                    break;
                                }
                            }
                            for (let i = 0; i < this.filteredList.length; i++) {
                                if (this.filteredList[i].id == this.elementToDeleteId) {
                                    this.filteredList.splice(i, 1);
                                    break;
                                }
                            }
                            this.elementToDeleteId = null;
                        });
                }
            },
            changeFilter(type) {
                this.animationList = this.filteredList;
                this.animationList = type === 'alf' ? this.animationList.sort((a, b) => a.name.localeCompare(b.name)) : this.animationList.sort((a, b) => b.date_add.localeCompare(a.date_add));
                this.filterPractice();
                this.filterAnimation();
            },
            filterPractice() {
                this.filterAnimation(() => {
                    let input = this.inputText.toLowerCase();
                    let self = this;
                    this.filteredList = [];
                    if (input.length !== 0) {
                        this.animationList.filter(function (item) {
                            if (item.name.toLowerCase().includes(input))
                                self.filteredList.push(item)
                        })
                    } else {
                        this.filteredList = this.animationList;
                    }
                })
            },
            filterAnimation(callback) {
                'use strict';

                $(document).off('keyup', '#searchFilter');
                $(document).on('keyup', '#searchFilter', function (e) {
                    e.preventDefault();

                    $('.card').each(function () {
                        $(this).addClass('is-animated').stop().fadeOut(500);
                    });

                    setTimeout(() => {
                        if (callback) callback();
                        $('.card').each(function () {
                            $(this).removeClass('is-animated').addClass('is-animated-a').stop().fadeIn(500);
                        });
                    }, 550);
                });
            },
            filterDate() {
                let self = this;

                let dateFrom = $("#calendarPickerFrom").val();
                let dateTo = $("#calendarPickerTo").val();
                dateTo = (dateTo == "" ? null : moment(dateTo));
                dateFrom = (dateFrom == "" ? null : moment(dateFrom));

                this.filteredList = [];
                this.animationList.filter(function (item) {
                    let animationsDate = moment(item.date_add);

                    if (dateTo && dateFrom && animationsDate.isBetween(dateFrom, dateTo, null, '[]')) {
                        self.filteredList.push(item);
                    } else if (dateTo && !dateFrom && animationsDate.isSameOrBefore(dateTo)) {
                        self.filteredList.push(item);
                    } else if (dateFrom && !dateTo && animationsDate.isSameOrAfter(dateFrom)) {
                        self.filteredList.push(item);
                    } else if (!dateFrom && !dateTo) {
                        self.filteredList.push(item);
                    }

                })
            },
            showFilters() {
                if ($('.projectsNavigation div.filterOptions').hasClass('showFilter')) {
                    $('.projectsNavigation .filterOptions').removeClass('showFilter');
                } else {
                    $('.projectsNavigation .filterOptions').addClass('showFilter');
                }
            },
            changeFolder(activeFolder){
                this.activeFolder = activeFolder;
                this.$refs.folders.getContent()
                    .then((response) => {
                        this.animationList = response;
                        this.filteredList = this.animationList;
                    })
            }
        },
        mounted: function () {
            let self = this;

            $(document).off('keyup', '#searchFilter');
            $(document).on('keyup', '#searchFilter', this.filterPractice);

            $('.calendarPicker').datetimepicker({
                format: "Y-m-d",
                timepicker: false,
                language: 'pl-PL',
                autoclose: true,
            });

            $(document).off('change', '.calendarPicker');
            $(document).on('change', '.calendarPicker', function () {
                self.filterDate();
            });
        },
    }
</script>
<style>
    .left-friends-list,
    .right-friends-list {
        min-width: 200px;
        max-height: 260px;
        overflow-y: auto;
    }

    #shareModal .card:hover {
        cursor: pointer;
    }

    .header-list {
        margin-bottom: 20px;
    }

    .share-titles {
        align-items: center;
        justify-content: center;
        display: flex;
    }

    .modal-body .card {
        width: 300px;
        margin-bottom: 10px;
    }

    .modal-body .row-12 {
        width: 670px;
    }

    .card .card-body {
        padding: 10px;
    }

    .deleteFriend {
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 10px;
        line-height: 12px;
        text-align: center;
        height: 12px;
        width: 12px;
        padding: 5px;
        background: #6e52a8;
        color: white;
        cursor: pointer;
        border-radius: 50%;
        transition: all .2s;
    }

    .deleteFriend:hover {
        transform: rotate(90deg);
    }

    .deleteFriend i {
        margin: 0;
    }

    @media only screen and (max-width: 960px) {
        .modal-body .center-flex-a {
            flex-direction: column;
        }

        .header-list {
            flex: 1;
            text-align: center;
            padding: 10px;
            margin-bottom: 0px;
        }

        .header-list:hover {
            background: #6E53A8;
            color: white !important;
            cursor: pointer;
        }

        .left-friends-list,
        .right-friends-list {
            padding-right: 20px;
        }

        .modal-body .row-12 {
            width: auto;
        }
    }
</style>